import React from "react";
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBRow, MDBCol, MDBBtn, MDBContainer } from "mdbreact";

import Upload from "../Upload/Upload";


import DatePicker,{registerLocale,setDefaultLocale} from "react-datepicker";
import ja from 'date-fns/locale/ja';

import "react-datepicker/dist/react-datepicker.css";
import "./P4Bills.css";

import firebase from "../../firebase"

registerLocale('ja', ja);
setDefaultLocale('ja')

class P4Bills extends React.Component {
  constructor(props) {
    const dt = new Date();
    super(props);
    this.state = {
      estNum: '',
      startDate: new Date(),
      startDate2: new Date(dt.getFullYear()+1,dt.getMonth(),dt.getDate()),
      title: '',
      toUser: '',
      files: [],
      modal: false,
      errModal: false,
    }
  }

  handleNumChange = (e) => {
    this.setState({
      estNum: e.currentTarget.value
    });
  }
  handleChange = date => {
    this.setState({
      startDate: date
    });
  };
  handleChange2 = date => {
    this.setState({
      startDate2: date
    });
  };

  handleTitleChange = (e) => {
    this.setState({
      title: e.currentTarget.value
    });
  }
  handleToUserChange = (e) => {
    if (e.currentTarget.selectedIndex > 0) {
      this.setState({
        toUserName: e.currentTarget.options[e.currentTarget.selectedIndex].dataset.name,
        toUser: e.currentTarget.value
      });
    } else {
      this.setState({
        toUserName: '',
        toUser: ''
      });
    }
  }

  modalClose = () => {
    this.setState({
      modal: false,
      title: '',
      toUser: '',
      files: [],
    })
    this.refs.UploadComponent.resetFile();
  }
  errModalClose = () => {
    this.setState({
      errModal: false
    })
  }



  fileUpload = (e) => {
    e.preventDefault();

    console.log("fileUpload",e);
    console.log(this.state.files[0]);


    if(this.state.files.length > 0){
      const file = this.state.files[0];

      //this.props.storage.refFromURL(this.props.src);
      console.log(file.name);

      var fileRef = this.props.storage.ref().child('p4bills/' + '/' + this.props.user.id + '/' + file.name);

      fileRef.getDownloadURL().then((onResolve) => {
        console.log("Same File Exist");
        this.setState({
          errModal: true,
        })
      }, (onReject) => {
        console.log(fileRef.bucket);
        console.log(fileRef.fullPath);

        fileRef.put(file).then(function(snapshot) {
          console.log('Uploaded a blob or file!');
        });
        this.dataSet(fileRef);

      });
    }
  }

  dataSet = (snapshot) => {

    console.log("dataSet");
    console.log(this.state.startDate);
    console.log(this.state.startDate2);

    let billRef = this.props.db.collection('p4bills').doc();
    let dueDate = new Date(this.state.startDate);

    let setWithMerge = billRef.set({
      title: this.state.title,
      number: this.state.estNum,
      date: firebase.firestore.Timestamp.fromDate(this.state.startDate),
      //endDate: firebase.firestore.Timestamp.fromDate(this.state.startDate2),
      dueDate: dueDate.getTime(),
      toUser: this.state.toUser,
      toUserName: this.state.toUserName,
      toOrganization: this.props.org.id,
      fromUser: this.props.user.id,
      fromUserName: this.props.user.last_name + this.props.user.first_name,
      fromOrganization: this.props.userOrg?.id,
      created: firebase.firestore.Timestamp.fromDate(new Date()),
      file: snapshot.fullPath,
    }, { merge: true });
    this.setState({
      modal: true,
    })
  }

  componentDidMount() {
  }

  onFilesAdded = (files) => {
    this.setState({
      files: files
    });
    console.log(files);
  }

  handleInputChange = inputName => value => {
    const nextValue = value;
    this.setState({
        [inputName]: nextValue
    });
  };

  render() {
    const isEnable = (this.state.files.length > 0)
    && (this.state.estNum !== '')
    && (this.state.startDate !== '')
    && (this.state.startDate2 !== '')
    && (this.state.title !== '')
    && (this.state.toUser !== '');

    if (!this.props.org) {
      return (
        <>
          取引先を選択してください。
        </>
      )
    }

    let urigawa = false;
    if (this.props.userOrg && this.props.userOrg.administrator && this.props.org)
    {
      urigawa = true;
    }
    if(! urigawa){
      return (
        <>
        </>
      )
    }

    return (
      <>
      <MDBContainer>
        <MDBRow>
          <MDBCol md="12" className="mb-3">
            <h2>請求書登録</h2>
            <form>
            <label htmlFor="estNum" className="grey-text">
              請求番号
            </label>
            <input
              type="text"
              id="estNum"
              className="form-control"
              name="estNum"
              onChange={this.handleNumChange}
              value={this.state.estNum}
            />
            <br />

            <label htmlFor="billDate" className="grey-text">
              発行日付指定
            </label>
            <DatePicker
              dateFormat="yyyy/MM/dd"
              id="billDate"
              className="form-control"
              selected={this.state.startDate}
              onChange={this.handleChange}
              locale="ja-JP"
            />
            <br />

            <label htmlFor="billTitle" className="grey-text">
              請求書タイトル
            </label>
            <input
              type="text"
              id="billTitle"
              className="form-control"
              name="title"
              onChange={this.handleTitleChange}
              value={this.state.title}
            />
            <br />

            <label htmlFor="billToUser" className="grey-text">
              相手先担当者選択
            </label>
            <select
              className="browser-default custom-select"
              id="billToUser"
              onChange={this.handleToUserChange}
              value={this.state.toUser}
              >
              <option>選択してください</option>
              {this.props.org && this.props.org.users &&
                this.props.org.users.map((user) =>
                  <option key={user.user} value={user.user} data-name={user.name}>{user.name}</option>
                )
              }
            </select>
            <br />

            <label htmlFor="billFile" className="grey-text">
              請求書PDF選択
            </label>
            <Upload onFilesAdded={this.onFilesAdded} ref="UploadComponent" />

            {false &&
            <div className="input-group">
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="billFile"
                  aria-describedby="inputGroupFileAddon01"
                />
                <label className="custom-file-label" htmlFor="inputGroupFile01">
                  ファイルを選択してください
                </label>
              </div>
            </div>
            }


            <div className="text-center mt-4">
              <MDBBtn
                color="default"
                type="submit"
                disabled={!isEnable}
                onClick={this.fileUpload}
              >新規請求書登録</MDBBtn>
            </div>
          </form>

          </MDBCol>
        </MDBRow>

        <MDBModal isOpen={this.state.modal} toggle={this.modalClose}>
          <MDBModalHeader toggle={this.modalClose}>登録完了</MDBModalHeader>
          <MDBModalBody>
            請求書を登録しました
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn onClick={this.modalClose}>確認</MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={this.state.errModal} toggle={this.errModalClose}>
          <MDBModalHeader className="warning-color-dark white-text" toggle={this.errModalClose}>重複確認</MDBModalHeader>
          <MDBModalBody>
            同名の請求書が存在するので処理を中止しました。
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="orange darken-3" onClick={this.errModalClose}>確認</MDBBtn>
          </MDBModalFooter>
        </MDBModal>


      </MDBContainer>
      </>
    )
  }
}
export default P4Bills;

